// eslint-disable-next-line import/prefer-default-export
export const EPWORTH_LEVEL = Object.freeze({
  POSITIVE: `positive`,
  NEUTRAL: `neutral`,
  NEGATIVE: `negative`,
})

export const DBAS_LEVEL = Object.freeze({
  LOW: `low`,
  HIGH: `high`,
  LOW_FLAGGED: `low_flagged`,
})

export const EPWORTH_SCORE_MIN = 0
export const EPWORTH_SCORE_MAX = 24

export const DBAS_SCORE_MIN = 1
export const DBAS_SCORE_MAX = 10
